import React, {useContext} from 'react';
import {innerStyle} from "../../../../../styles/pages/home/MaterialYouBaseStyle";
import {Avatar, Button, Card, CardContent, Paper, Slide, TextField, Typography, Zoom} from "@mui/material";
import Grid from "@mui/material/Grid";
import logo from "../../../../../assets/v2/Logo-Orca.svg";
import {amber, green, indigo, red} from "@mui/material/colors";
import IconButton from "@mui/material/IconButton";
import ArrowBackIosRoundedIcon from "@mui/icons-material/ArrowBackIosRounded";
import {useHistory} from "react-router-dom";
import {AppContext} from "../../../../../App";
import {setThemeType} from "../../../../../services/AppServices";
import NightsStayTwoToneIcon from "@mui/icons-material/NightsStayTwoTone";
import WbSunnyTwoToneIcon from "@mui/icons-material/WbSunnyTwoTone";

const MessaggiPage = () => {
	const classes = innerStyle();
	let history = useHistory();
	const appContext = useContext(AppContext);
	
	return (
        <React.Fragment>
            <main className={classes.main}>
				<header style={{
					display: "flex",
					justifyContent: "center",
					paddingBottom: 28,
					paddingTop: 20,
				}}>
					<Avatar src={logo} variant="circular" className={classes.logo}/>
					<Typography variant={"h1"} component={"h1"} align={"center"}
					            style={{color: indigo["A700"]}}>
						<b>
							<span style={{color: red[500]}}>c</span>
							<span style={{color: amber[500]}}>e</span>
							<span style={{color: indigo["A700"]}}>a</span>
							<span style={{color: green[500]}}>n</span>
						</b>
					</Typography>
				</header>
				<Grid container spacing={4} component={"article"} style={{padding: 20}}>
					<Grid item xs={12}>
						<Slide direction={"up"} in={true} mountOnEnter unmountOnExit style={{transitionDelay: "200ms"}}>
							<Paper className={classes.paper}>
								<Zoom in={true} style={{transitionDelay: "400ms"}}>
									<IconButton
                                        className={classes.backButton}
                                        onClick={() => history.goBack()}
                                        size="large">
										<ArrowBackIosRoundedIcon fontSize="small"/>
									</IconButton>
								</Zoom>
								<Typography variant={"h4"} component={"h1"}
								            style={{paddingLeft: 6, display: "inline-block", verticalAlign: "bottom"}}>
									<b>Messaggi</b>
								</Typography>
								<Typography variant={"subtitle2"} color={"textSecondary"} style={{paddingLeft: 6}}>
									Visualizza o rilascia un messaggio all'ICT
								</Typography>
								<div className={classes.flexStart}>
									<Zoom in={true} style={{transitionDelay: "600ms"}}>
										<Card elevation={0} className={classes.messageItem}>
											<CardContent>
												<Typography variant={"subtitle1"}>
													<b>Aggiornamento del 10/02/2022</b>
												</Typography>
												<Typography variant={"caption"}>
													Lorem ipsum dolor sit amet, consectetur adipiscing elit. Fusce nisi nulla, fringilla quis leo
													ac,
													pretium vehicula enim. Nunc viverra quis turpis non suscipit. Integer non interdum risus, non
													scelerisque tellus. Aliquam magna nisi, condimentum et maximus non, dignissim at sem. Aliquam
													consectetur orci nec vulputate rutrum. Sed quis mauris rutrum, rhoncus eros ac, porta enim. In
													urna
													neque, iaculis vel malesuada eu, accumsan a mauris. Ut vel molestie risus.
												</Typography>
											</CardContent>
										</Card>
									</Zoom>
									<Zoom in={true} style={{transitionDelay: "500ms"}}>
										<Card elevation={0} className={classes.messageItem}>
											<CardContent>
												<Typography variant={"subtitle1"}>
													<b>Aggiornamento del 01/01/2022</b>
												</Typography>
												<Typography variant={"caption"}>
													Aliquam
													consectetur orci nec vulputate rutrum. Sed quis mauris rutrum, rhoncus eros ac, porta enim. In
													urna
													neque, iaculis vel malesuada eu, accumsan a mauris. Ut vel molestie risus.
												</Typography>
											</CardContent>
										</Card>
									</Zoom>
								</div>
								<TextField variant={"filled"} multiline={true} fullWidth={true} rows={8} id={"feedback"}
								           style={{marginTop: 20, marginBottom: 20}} className={classes.textFiled}
								/>
								<div className={classes.flexEnd}>
									<Button className={classes.button} style={{borderRadius: 22}} variant={"contained"} disableElevation
									        onClick={() => alert("Ok va bene, grazie per questo tuo commento...")}>
										<b>Invia opinione</b>
									</Button>
								</div>
							</Paper>
						</Slide>
					</Grid>
					<Grid item xs={12}
					      style={{
						      display: "flex",
						      alignItems: "center",
						      alignContent: "center",
						      justifyContent: "center",
						      position: "relative"
					      }}>
						<Typography variant={"caption"} color={"textSecondary"} align={"center"}>
							Atlantis© 2022<br/>
							Atlantis S.p.A 2022-2027<br/>
							Via San Paolo 33, Torino, TO
						</Typography>
						
						<IconButton
                            style={{position: "absolute", right: 4, bottom: 4}}
                            onClick={() => setThemeType(appContext.state.theme.palette.mode === "light" ? "dark" : "light",
                                appContext.state.theme, appContext.dispatch)}
                            size="large">
							{appContext.state.theme.palette.mode === "light" ? <NightsStayTwoToneIcon/> : <WbSunnyTwoToneIcon/>}
						</IconButton>
					</Grid>
				</Grid>
			</main>
        </React.Fragment>
    );
}

export default React.memo(MessaggiPage)
